import { useMaintenanceApi } from '../services/api/maintenanceApi';
import { useState, useEffect } from 'react';

interface TipoPago {
  Id: number;
  Nombre: string;
  Activo: boolean;
  Eliminado: boolean;
}

export const useTiposPagoApi = () => {
  const [tiposPago, setTiposPago] = useState<TipoPago[]>([]);
  const maintenanceApi = useMaintenanceApi('tipos-pago');

  useEffect(() => {
    loadTiposPago();
  }, []);

  const loadTiposPago = async () => {
    const data = await maintenanceApi.getAll();
    setTiposPago(data);
  };

  return { tiposPago, isLoading: maintenanceApi.isLoading };
};